import {
  GET_FUND_MANAGERS_REQUEST,
  GET_FUND_MANAGERS_SUCCESS,
  GET_FUND_MANAGERS_FAILED,
  GET_HEDGE_USER_FREE_SLOTS_REQUEST,
  GET_HEDGE_USER_FREE_SLOTS_SUCCESS,
  GET_HEDGE_USER_FREE_SLOTS_FAILED,
  GET_ALL_USERS_REQUEST,
  GET_ALL_USERS_SUCCESS,
  GET_ALL_USERS_FAILED,
  CREATE_APPOINTMENT_REQUEST,
  CREATE_APPOINTMENT_SUCCESS,
  CREATE_APPOINTMENT_FAILED,
  CREATE_CHAT_ROOM_INIT,
  CREATE_CHAT_ROOM_SUCCESS,
  CREATE_CHAT_ROOM_FAILED,
  INVEST_IN_FUND_REQUEST,
  INVEST_IN_FUND_SUCCESS,
  INVEST_IN_FUND_FAILED,
  CREATE_NOTES_INIT,
  CREATE_NOTES_SUCCESS,
  CREATE_NOTES_FAILED,
  GET_NOTES_INIT,
  GET_NOTES_SUCCESS,
  GET_NOTES_FAILED,
  SEARCH_PMRESULT_INIT,
  SEARCH_PMRESULT_SUCCESS,
  SEARCH_PMRESULT_FAILED,
  SEARCH_RPRESULT_INIT,
  SEARCH_RPRESULT_SUCCESS,
  SEARCH_RPRESULT_FAILED,
  SEARCH_REPORTRESULT_INIT,
  SEARCH_REPORTRESULT_SUCCESS,
  SEARCH_REPORTRESULT_FAILED,
  CREATE_AUDITLOGS_INIT,
  CREATE_AUDITLOGS_SUCCESS,
  CREATE_AUDITLOGS_FAILED,
  GET_ALL_ADMIN_LIST_INIT,
  GET_ALL_ADMIN_LIST_SUCCESS,
  GET_ALL_ADMIN_LIST_FAILED,
  GET_ALLOCATOR_USERS_INIT,
  GET_ALLOCATOR_USERS_SUCCESS,
  GET_ALLOCATOR_USERS_FAILED,
  GET_HEDGEFUND_DETAIL_INIT,
  GET_HEDGEFUND_DETAIL_SUCCESS,
  GET_HEDGEFUND_DETAIL_FAILED,
  GET_FUND_DETAILS_SUCCESS,
  GET_FUND_DETAILS_INIT,
  GET_FUND_DETAILS_FAILED,
  GET_FUND_BIO_USER_INIT,
  GET_FUND_BIO_USER_SUCCESS,
  GET_FUND_BIO_USER_FAILED
} from "./constants";
const initialState = {
  loading: false,
  fundLoading: false,
  fund: {},
  fundStats: {},
  fundId: 0,
  investBtnLoading: false,
  roomCreationLoading: false,
  notesLoading: false,
  monthlyReturnPerformance: [],
  hedgeFund: {},
  fundManagers: [],
  freeSlots: [],
  users: [],
  riskReportMonths: [],
  riskReportByMonth: {},
  fundDecks: [],
  notes: [],
  pmLoading: false,
  performanceMetrcisMonth: [],
  selectedId: 0,
  riskReportMonthList: [],
  reportExtractData: {},
  adminList: [],
  allocatorUsers: [],
  fundBioUsers : [],
  bioLoading : false,
  userLoading: false,
};

const months = {
  1: "january",
  2: "february",
  3: "march",
  4: "april",
  5: "may",
  6: "june",
  7: "july",
  8: "august",
  9: "september",
  10: "october",
  11: "november",
  12: "december",
};

export default function hedgeFundDetailStore(state = initialState, action) {
  const toObject = (arr) => {
    return arr.reduce(function (acc, cur, i) {
      acc[months[cur.month]] = cur.monthlyReturn?.toFixed(2);
      return acc;
    }, {});
  };
  switch (action.type) {
    case GET_HEDGEFUND_DETAIL_INIT:
      return { ...state, loading: true, hedgeFund: {}, reportExtractData: {} };
    case GET_HEDGEFUND_DETAIL_SUCCESS:

      const fundData = action.payload.fund;
      let performanceMetrics = [];
      let fundStats = [];
      if (fundData?.id === window._env_.EthosFundId) {
        const publicFund = action.payload.funds[0];
        fundStats = [
          {
            annualVolatility: "",
            annualizedReturn: "",
            followed: true,
            id: 7,
            isPrivate: publicFund?.isPrivate,
            monthlyReturn: publicFund?.monthlyReturn,
            name: publicFund?.name,
            ytd: publicFund?.ytd,
          },
          {
            annualVolatility: publicFund?.annualVolatility,
            annualizedReturn: publicFund?.annualizedReturn,
            id: 0,
            monthlyReturn: "",
            name: window._env_.EthosFundTitle,
            ytd: "",
          }
        ]
      }
      fundData?.monthlyReturnPerformances.map((p) => {
        return performanceMetrics.push({
          year: p.year,
          ytd: p.ytd,
          ...toObject(p.monthsData),
        });
      });
      const publicFunds = fundData?.id === window._env_.EthosFundId ? fundStats : action.payload.funds ;
      return {
        ...state,
        loading: false,
        hedgeFund: action.payload,
        monthlyReturnPerformance: performanceMetrics,
        fundDecks: action?.payload.decks,
        fund: fundData,
        fundId: fundData.id,
        fundStats:  publicFunds
      };
    case GET_HEDGEFUND_DETAIL_FAILED:
      return { ...state, loading: false };
    case GET_FUND_DETAILS_INIT:
      return { ...state, fundLoading: true, fund: {}, reportExtractData: {} };
    case GET_FUND_DETAILS_SUCCESS:
      const currentFund = action.payload
      let performance = [];

      currentFund?.monthlyReturnPerformances.map((p) => {
        return performance.push({
          year: p.year,
          ytd: p.ytd,
          ...toObject(p.monthsData),
        });
      });
      return {
        ...state,
        fundLoading: false,
        monthlyReturnPerformance: performance,
        fund: currentFund,
        fundId: currentFund.id
      };
    case GET_FUND_DETAILS_FAILED:
      return { ...state, fundLoading: false };
    case GET_FUND_MANAGERS_REQUEST:
      return { ...state };
    case GET_FUND_MANAGERS_SUCCESS:
      return { ...state, fundManagers: action.payload };
    case GET_FUND_MANAGERS_FAILED:
      return { ...state };
    case GET_HEDGE_USER_FREE_SLOTS_REQUEST:
      return { ...state };
    case GET_HEDGE_USER_FREE_SLOTS_SUCCESS:
      return { ...state, freeSlots: action.payload };
    case GET_HEDGE_USER_FREE_SLOTS_FAILED:
      return { ...state };
    case GET_ALL_USERS_REQUEST:
      return { ...state };
    case GET_ALL_USERS_SUCCESS:
      return { ...state, users: action.payload };
    case GET_ALL_USERS_FAILED:
      return { ...state };
    case CREATE_APPOINTMENT_REQUEST:
      return { ...state, loading: true };
    case CREATE_APPOINTMENT_SUCCESS:
      return { ...state, loading: false };
    case CREATE_APPOINTMENT_FAILED:
      return { ...state, loading: false };
    case CREATE_CHAT_ROOM_INIT:
      return { ...state, roomCreationLoading: true };
    case CREATE_CHAT_ROOM_SUCCESS:
      return { ...state, roomCreationLoading: false };
    case CREATE_CHAT_ROOM_FAILED:
      return { ...state, roomCreationLoading: false };
    case INVEST_IN_FUND_REQUEST:
      return { ...state, investBtnLoading: true };
    case INVEST_IN_FUND_SUCCESS:
      let updatedFund = Object.assign(
        {},
        state.fund,
        { selectedId: action.selectedInvestorId },
        { invested: true }
      );
      return {
        ...state,
        fund: { ...updatedFund },
        investBtnLoading: false,
      };
    case INVEST_IN_FUND_FAILED:
      return { ...state, investBtnLoading: false };
    case CREATE_NOTES_INIT:
      return { ...state, notesLoading: true };
    case CREATE_NOTES_SUCCESS:
      var noteList = state.notes;
      var note = [action.payload, ...noteList];

      return { ...state, notes: note, notesLoading: false };
    case CREATE_NOTES_FAILED:
      return { ...state, notesLoading: false };
    case GET_NOTES_INIT:
      return { ...state, notesLoading: true };
    case GET_NOTES_SUCCESS:
      return { ...state, notesLoading: false, notes: action.payload };
    case GET_NOTES_FAILED:
      return { ...state, notesLoading: false };
    case SEARCH_PMRESULT_INIT:
      return { ...state, pmLoading: true };
    case SEARCH_PMRESULT_SUCCESS:
      return { ...state, performanceMetrcisMonth: action.payload, pmLoading: false };
    case SEARCH_PMRESULT_FAILED:
      return { ...state, pmLoading: false };
    case SEARCH_RPRESULT_INIT:
      return { ...state, pmLoading: true };
    case SEARCH_RPRESULT_SUCCESS:
      return { ...state, riskReportMonthList: action.payload, pmLoading: false };
    case SEARCH_RPRESULT_FAILED:
      return { ...state, pmLoading: false };
    case SEARCH_REPORTRESULT_INIT:
      return { ...state, pmLoading: true };
    case SEARCH_REPORTRESULT_SUCCESS:
      return { ...state, reportExtractData: action.payload, pmLoading: false };
    case SEARCH_REPORTRESULT_FAILED:
      return { ...state, pmLoading: false };
    case CREATE_AUDITLOGS_INIT:
      return { ...state };
    case CREATE_AUDITLOGS_SUCCESS:
      return { ...state };
    case CREATE_AUDITLOGS_FAILED:
      return { ...state };
    case GET_ALL_ADMIN_LIST_INIT:
      return { ...state };
    case GET_ALL_ADMIN_LIST_SUCCESS:
      return { ...state, adminList: action.payload };
    case GET_ALL_ADMIN_LIST_FAILED:
      return { ...state };

    case GET_ALLOCATOR_USERS_INIT:
      return { ...state, allocatorUsers: [], userLoading: true };
    case GET_ALLOCATOR_USERS_SUCCESS:
      return {
        ...state,
        allocatorUsers: action.payload,
        userLoading: false,
      };
    case GET_ALLOCATOR_USERS_FAILED:
      return { ...state, userLoading: false };

    case GET_FUND_BIO_USER_INIT:
      return { ...state, bioLoading: true };
    case GET_FUND_BIO_USER_SUCCESS:
      return {
        ...state,
        fundBioUsers: action.payload,
        bioLoading: false,
      };
    case GET_FUND_BIO_USER_FAILED:
      return { ...state, bioLoading: false };
    default:
      return state;
  }
}
